import { IGiaiDoanActionTypes } from "../../action-types/ke-hoach/IGiaiDoanActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IGiaiDoanReducer } from "../../reducer-model/ke-hoach/IGiaiDoanReducer";
const iniState: IGiaiDoanReducer = {
  status: eReducerStatusBase.is_not_initialization,
  giaiDoans: [],
  nam_hoc: "",
  hoc_ky: 0,
  selectedIds: []
};
export const giaiDoanReducer = (
  state: IGiaiDoanReducer = iniState,
  action: IGiaiDoanActionTypes
): IGiaiDoanReducer => {
  switch (action.type) {
    case "GIAI_DOAN_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        nam_hoc: action.payload
      };
    case "GIAI_DOAN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        giaiDoans: action.payload,
      };
    case "GIAI_DOAN_LOAD_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "GIAI_DOAN_SHOW_EDIT_MODAL":
      return {
        ...state,
        giaiDoanEditing: action.payload,
        isShowEditModal: true
      };
    case "GIAI_DOAN_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false
      };
    case "GIAI_DOAN_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      };
    case "GIAI_DOAN_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "GIAI_DOAN_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "GIAI_DOAN_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting
      };
    case "GIAI_DOAN_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      };
    case "GIAI_DOAN_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "GIAI_DOAN_CHANGE_SELECTED_IDS":
      return {
        ...state,
        selectedIds: action.payload
      };
    default:
      return state;
  }
};
